<div class="export-timeSheet-section" *ngIf="isAdmin || isManager">
  <div class="export-utility-panel">
    <div class="export-utility-header">
      <h3 class="utility-title">Bulk Team Export</h3>
      <p class="utility-description">Export team-wide report data for the selected date range. This export is separate from the report shown above.</p>
    </div>

    <div class="export-steps-flow">
      <div class="step-item">
        <span class="step-number">1</span>
        <div class="step-content">
          <label class="step-label">Team</label>
          <mat-form-field appearance="outline" class="step-field">
            <mat-select (selectionChange)="teamSelectionChange()" [(ngModel)]="selectedTeam" placeholder="Select a team">
              <mat-option [value]="null">All Teams</mat-option>
              @for (team of teamsListForFilter; track $index) {
              <mat-option [value]="team.title.rendered" (click)="teamSelected(team)">
                {{team.title.rendered}}
              </mat-option>
              } @empty {
              <mat-option disabled>No Teams Available</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="step-divider"></div>

      <div class="step-item">
        <span class="step-number">2</span>
        <div class="step-content">
          <label class="step-label">Date Range</label>
          <mat-form-field appearance="outline" class="step-field date-field">
            <mat-date-range-input [rangePicker]="picker" [min]="minDate" [max]="maxDate">
              <input matStartDate [(ngModel)]="startDate" name="startDate" placeholder="Start"
                (dateChange)="onStartDateChange($event)">
              <input matEndDate [(ngModel)]="endDate" name="endDate" placeholder="End">
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
          <span class="field-help">Maximum 31 days</span>
        </div>
      </div>

      <div class="step-divider"></div>

      <div class="step-item action-item">
        <span class="step-number">3</span>
        <div class="step-content">
          <label class="step-label">&nbsp;</label>
          <button mat-flat-button class="export-action-btn" (click)="exportTimeSheet()">
            <mat-icon>download</mat-icon>
            Export Team CSV
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
